module.exports = __webpack_public_path__ + "img/qlcjy_charact_4.6a27edc7.svg";